<div class="kxi-basic-tile orca kxi-tile-shadows comparison-side-pane-item__card">
  <div
    class="comparison-side-pane-item__border"
    [style.border-left-color]="comparison()?.color"
  ></div>

  <div class="comparison-side-pane-item__body">
    <div class="comparison-side-pane-item__title" [matTooltip]="comparison()?.title">
      {{ comparison()?.title }}
    </div>

    @for (filter of comparison()?.filters ?? []; track filter; let i = $index) {
      <div class="comparison-side-pane-item__filter-row">
        <div class="comparison-side-pane-item__filter-icon">
          @switch (comparison()?.type) {
            @case ('date') {
              <xi-icon icon="calendar"></xi-icon>
            }
            @case ('keyword') {
              <xi-icon icon="app_explore"></xi-icon>
            }
            @case ('numeric') {
              <xi-icon icon="page_count"></xi-icon>
            }
          }
        </div>
        <div
          class="comparison-side-pane-item__filter-color"
          [style.background-color]="filter.color"
        ></div>
        <div class="comparison-side-pane-item__filter-value">
          {{ filterDisplayValues[i] }}
        </div>
        <div
          class="comparison-side-pane-item__filter-field"
          [class.ellipsis-loader]="!filterAnalyticItems[i]"
        >
          {{ filterAnalyticItems[i] }}
        </div>
      </div>
    }
  </div>

  @if (isEditable && !isDisabled) {
    <div class="comparison-side-pane-item__menu" [matTooltip]="menuTooltip">
      <span
        [matMenuTriggerFor]="comparisonMenuTrigger"
        [class.comparison-side-pane-item__menu--disabled]="!!isDisabled"
      >
        <xi-icon-button
          icon="kabob"
          color="CXIC"
          buttonSize="large"
          [disabled]="!!isDisabled"
        ></xi-icon-button>
      </span>
    </div>
  }
</div>

<mat-menu #comparisonMenuTrigger class="menu-with-xi-icons">
  <ng-template matMenuContent *transloco="let t; read: 'comparison-side-panel-item-component'">
    <button mat-menu-item (click)="triggerItemAction('edit')">
      <div>{{ t('edit') }}</div>
    </button>

    <button mat-menu-item (click)="triggerItemAction('apply')">
      <div>{{ t('apply') }}</div>
    </button>

    @if (isEditable) {
      <button mat-menu-item (click)="triggerItemAction('clone')">
        <div>{{ t('clone') }}</div>
      </button>
    }
    @if (isEditable) {
      <button
        mat-menu-item
        [matMenuTriggerFor]="pagesSubMenu"
        [disabled]="dashboardPages.length === 1"
      >
        <div>{{ t('clone-another') }}</div>
      </button>
    }
    @if (isEditable) {
      <button mat-menu-item (click)="triggerItemAction('delete')">
        <div>{{ t('delete') }}</div>
      </button>
    }
  </ng-template>
</mat-menu>

<mat-menu #pagesSubMenu class="comparison__pages-submenu">
  <ng-template matMenuContent>
    @for (page of dashboardPages; track page) {
      <button
        mat-menu-item
        [disabled]="page.id === currentDashboardPageId"
        (click)="triggerItemAction('clone', { pageId: page.id })"
      >
        {{ page.title }}
      </button>
    }
  </ng-template>
</mat-menu>
